export const AWS_REGION = 'us-west-1';
export const AWS_IOT_ENDPOINT =
  'a35ya93edm4bsg-ats.iot.us-west-1.amazonaws.com';
export const AWS_COGNITO_IDENTITY_POOL_ID =
  'us-west-1:d0c94684-fec1-400a-aff4-2b40c07ac39a';
// export const AWS_COGNITO_IDENTITY_POOL_ID = "us-west-1:07a85f42-98bb-4140-9a4c-6a81d37aa52b";
